(function(){

    checkMobileMenu()

    $( window ).resize(function() {
        checkMobileMenu()
      });

    function checkMobileMenu() {
        if(window.matchMedia('(max-width:1279px)').matches) {
            $('.navigation-wrap').addClass('mobile-nav');
        } else {
            $('.navigation-wrap').removeClass('mobile-nav');
        }
    }

    function openMenu(){

        var overlaymenu = $('.overlay_menu_open');
        var self = this;

        this.init = function($obj){
            this.clear($obj);
            this.open($obj);
        }

        this.clear = function($obj , $all = false){
            if(!$all){
                if ( ($obj).hasClass('open') ) return;
            }

            $('.menu_links').each(function( index ) {
                $(this).removeClass('open');
            });  
            overlaymenu.removeClass('showbg')
            
        }

        this.open = function($obj){
            $obj.addClass('open');
            overlaymenu.addClass('showbg');

            overlaymenu.on('click',function(){
                self.clear($obj);
            });
        }

    }

    $('.overlay_menu_open').on("click", function(){
        new openMenu().clear('',true);
        setTimeout(function(){
            $('.ccMenuLink').addClass('black');
            $('.ccMenuLink').siblings().removeClass('grey');
        },300);
    });

    $('.menu_wrp').on('mouseleave',function(){
        var mobileD = 1280;
        if(window.outerWidth < mobileD ) return;
        new openMenu().clear('',true);
        setTimeout(function(){
            $('.ccMenuLink').addClass('black');
            $('.ccMenuLink').siblings().removeClass('grey');
        },300);
    });

    //Open mobile main menu
    $('.ccMenuLink').on("click", function(){
        $('.ccMenuLink').each(function(){
            $(this).removeClass('open');
            $(this).removeClass('black');
            $(this).removeClass('grey');
        })
        $(this).addClass('open');
        $(this).addClass('black');
        $(this).siblings().addClass('grey');
        var menu = $(this).data("menu");
        var obj = $('#'+menu);
        new openMenu().init(obj);
        return false;
    });




    function openMobile(){
        var overlaymenu = $('.overlay_menu_open');
        var menucontainer = $('.navigation-wrap');
        var body = $('body');


        this.open = function($obj){
            $obj.addClass('open');
            menucontainer.addClass('mobileopen');
            overlaymenu.addClass('showbg');
            body.addClass('grid block');
        };

        this.close = function($obj){
            
            $('.menu_links').each(function(){
                $(this).removeClass('open');
            })

            $obj.removeClass('open');
            menucontainer.removeClass('mobileopen');
            $('.ccMenuLink').each(function(){
                $(this).removeClass('open');
            }) 
            overlaymenu.removeClass('showbg');
            body.removeClass('block');
        };
    }

    $('.overlay_menu_open').on('click',function(){
        if($('#ccBurgher').hasClass('open')) {
            new openMobile().close($('#ccBurgher'));
        }
    })

    $('#ccBurgher').on('click',function(){
        if($(this).hasClass('open')){
            new openMobile().close($(this));
        }else{
            new openMobile().open($(this));
            //Apri di defaul la prima scheda di menu.
            $('.ccml1').addClass('open');
            setTimeout(function(){
                var obj = $('#ccMenu_link1');
                new openMenu().init(obj);
            },50);
        }
       return false;
    });


    $('#cart-icon').on('click', function(){
        if(window.innerWidth > 720) {
          $('.drawer__inner').height($('ul.list-menu').height() + 30);
        }
        $('.drawer').addClass('active');
        console.log('active');
        setTimeout(function(){
            $('.drawer').addClass('show');
        },200);
        return false;
    });


    $('#mobile-cart-icon-wrp').on('click', function(){
        $('.drawer').addClass('active');
        setTimeout(function(){
            $('.drawer').addClass('show');
        },200);
        return false;
    });

    $('#CartDrawer-Overlay').on('click', function(){
        $('.drawer').removeClass('active show');
    });

})();